import { z } from "zod";

/**
 * Billing cycle for subscriptions
 */
export const cicloFacturacionSchema = z.enum(["mensual", "anual"]);
export type CicloFacturacion = z.infer<typeof cicloFacturacionSchema>;
export const CICLOS_FACTURACION = cicloFacturacionSchema.options;

/**
 * Subscription status (aligned with backend)
 */
export const estadoSuscripcionSchema = z.enum([
	"pendiente",
	"tarjeta_registrada",
	"activa",
	"cancelada",
	"vencida",
	"prueba",
	"error",
]);
export type EstadoSuscripcion = z.infer<typeof estadoSuscripcionSchema>;
